import {
  AUTH_LOADING,
  LOG_OUT,
  RESET_FAILD,
  RESET_LOADING,
  RESET_SUCCESS,
  SIGN_IN,
  SIGN_IN_FAILED,
  TRY_AGAIN,
  RESET_AUTH,
  SIGN_IN_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  token: null,
  role: null,
  toUpdatePassword: null,
  exp: null,
  accountName: null,
  id: null,
  message: null,
  userId: null,
  partnerId: null,
  merchantId: null,
  partnerUserId: null,
  pgId: null,
  refreshToken: null,
  username: null,
  password: null,
  isStepOneComplete: false,
  isPrimary: null,
  merchantName: null,
  registeredMobileNumber: null,
  logo: null,
  merchantMobile: null,
  merchantEmail: null,
  email: null,
  country: null,
  city: null,
  tsn: null,
  outletId: null,
};

export const authReducer = (
  state = initialState,
  action: {
    type: any;
    loading: any;
    payload: any;
    refreshToken: any;
    role: any;
    toUpdatePassword: any;
    exp: any;
    accountName: any;
    error: any;
    id: any;
    userId: any;
    partnerId: any;
    merchantId: any;
    partnerUserId: any;
    pgId: any;
    isPrimary: any;
  },
) => {
  switch (action.type) {
    case AUTH_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
        username: action.payload?.username,
        password: action.payload?.password,
      };
    case SIGN_IN:
      return {
        ...state,
        loading: false,
        // token: action.payload.accessToken,
        // refreshToken: action.refreshToken,
        // role: action.role,
        // toUpdatePassword: action.payload.toUpdatePassword,
        // id: action.id,
        error: null,
        // message: null,
        // userId: action.userId,
        partnerId: action.partnerId,
        // pgId: action.pgId,
        isStepOneComplete: true,
      };

    case SIGN_IN_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        role: action.role,
        toUpdatePassword: action.payload.toUpdatePassword,
        exp: action.exp,
        accountName: action.accountName,
        id: action.id,
        error: null,
        message: null,
        userId: action.userId,
        partnerId: action.partnerId,
        pgId: action.pgId,
        password: null,
        isPrimary: action.isPrimary,
        merchantName: action.payload.merchantName,
        registeredMobileNumber: action.payload.registeredMobileNumber,
        logo: action.payload.logo,
        merchantMobile: action.payload.merchantMobile,
        merchantEmail: action.payload.merchantEmail,
        email: action.payload.email,
        country: action.payload.country,
        city: action.payload.city,
        tsn: action.payload.tsn,
        outletId: action.payload.outletId,
      };

    case SIGN_IN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        role: null,
        token: null,
        refreshToken: null,
        toUpdatePassword: null,
        message: null,
        id: null,
        userId: null,
        partnerId: null,
        merchantName: null,
        registeredMobileNumber: null,
        logo: null,
        merchantMobile: null,
        merchantEmail: null,
        email: null,
        country: null,
        city: null,
        tsn: null,
        outletId: null,
      };

    case TRY_AGAIN:
      //console.log("null")
      return {
        ...state,
        loading: false,
        error: null,
        role: null,
        token: null,
        toUpdatePassword: null,
        message: null,
        id: null,
        userId: null,
      };

    case LOG_OUT:
      return {
        ...state,
        loading: false,
        error: null,
        role: null,
        token: null,
        toUpdatePassword: null,
        message: action.payload,
        id: null,
        userId: null,
        partnerId: null,
        refreshToken: null,
        merchantName: null,
        registeredMobileNumber: null,
        logo: null,
        merchantMobile: null,
        merchantEmail: null,
        email: null,
        country: null,
        city: null,
        tsn: null,
        outletId: null,
      };

    case RESET_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case RESET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload,
      };

    case RESET_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: null,
      };
    case RESET_AUTH:
      return initialState;
    default:
      return state;
  }
};
